.Main {
    line-height: 1.7;
    padding: var(--small-space) 0 0 0;
    letter-spacing: 0.02em;
}

.Main p {
    padding: 0 0 1.7em 0;
}

.Image {
    padding: 0 0 1.7em 0;
}

.Image a {
    border-bottom: none;
}

.Main strong {
    font-weight: normal;
    font-variation-settings: "wght" 600;
}

.Main h1,
.Main h2,
.Main h3,
.Main h4,
.Main h5,
.Main h6 {
    font-size: 2em;
    line-height: 1.1;
    padding-bottom: 0.25em;
}

.Main a {
    text-decoration: none;
    border-bottom: solid 1px currentColor;
}